import { render, staticRenderFns } from "./BoskShortcutDate.vue?vue&type=template&id=01dd6bde"
import script from "./BoskShortcutDate.vue?vue&type=script&lang=js"
export * from "./BoskShortcutDate.vue?vue&type=script&lang=js"
import style0 from "./BoskShortcutDate.vue?vue&type=style&index=0&id=01dd6bde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports